import {
  ArrowUp,
  ArrowDown,
  IndentIncrease,
  IndentDecrease,
  CircleHelp,
  SmilePlus,
  Languages,
  type LucideIcon,
  type LucideProps,
  Check,
  ChevronDown,
  ChevronUp,
  ChevronsUpDown,
  Send,
  X,
  Minus,
  Bookmark,
  Heart,
  Star,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  Circle,
  Square,
  Triangle,
  Tag,
  Flag,
  Bell,
  User,
  Home,
  Settings,
  Zap,
  Award,
  Calendar,
  LogOut,
  Plus,
  File,
  FilePlusCorner,
  FileCheckCorner,
  Folder,
  FolderOpen,
  Archive,
  Mail,
  MessageSquare,
  PlusCircle,
  UserPlus,
  CreditCard,
  Keyboard,
  Users,
  ArrowUpDown,
  Wand,
  RotateCw,
  ChevronRight,
  Filter as FilterLucide,
  Text,
  Hash,
  List,
  ToggleLeft,
  PanelLeft,
  Upload,
  ChevronLeft,
  MoreHorizontal,
  EllipsisVertical,
  Share2,
  Undo2,
  Redo2,
  Pen,
  Paintbrush,
  Eraser,
  Info,
  CircleAlert,
  TriangleAlert,
  OctagonAlert,
  CircleCheck,
  Inbox,
  Search,
  FileText,
  Layers,
  Layout,
  GripVertical,
  Puzzle,
  BookMarked,
  Edit2,
  ClipboardPaste,
  LoaderCircle,
  Eye,
  EyeOff,
  Lock,
  Mic,
  Video,
  FileImage,
  FileVideoCamera,
  FileMusic,
  FileSpreadsheet,
  FileArchive,
  Play,
  Pause,
  Headphones,
  SkipBack,
  SkipForward,
  ListTodo,
  Brush,
  Image,
  Trash2,
  AlarmClock,
  Slash,
  Copy,
  Pencil,
  RotateCcw,
  ServerCog,
  Microscope,
  SearchCode,
  CodeXml,
  TreePalm,
  Route,
  Activity,
  Download,
  Maximize2,
  Minimize2,
  Phone,
  Briefcase,
  CircleUserRound,
  Volume2,
  Database,
  Globe,
  AlertCircle,
  Clock,
  ArrowLeft,
  XCircle,
  Server,
  ExternalLink,
  FileCode,
  Package,
  Bug,
  VolumeX,
  Sun,
  Moon,
  WifiOff,
  Rabbit,
  Turtle,
  CircleX,
  HardDrive,
  Cloud,
  createLucideIcon,
} from 'lucide-react'
import { cn } from '../lib/utils'

const Github = createLucideIcon('github', [
  [
    'path',
    {
      d: 'M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4',
      key: 'tonef',
    },
  ],
  ['path', { d: 'M9 18c-4.51 2-5-2-7-2', key: '9comsn' }],
])

const Youtube = createLucideIcon('youtube', [
  [
    'path',
    {
      d: 'M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17',
      key: '1q2vi4',
    },
  ],
  ['path', { d: 'm10 15 5-3-5-3z', key: '1jp15x' }],
])

// INFO: if you move this file, don't forget to update the main.md.

interface Icon extends LucideProps {
  icon: LucideIcon
}

export function Icon({
  icon: IconComponent,
  size = 24,
  className,
  ...props
}: Icon) {
  return (
    <IconComponent
      size={size}
      className={cn('transition-colors', className)}
      {...props}
    />
  )
}

export const CheckIcon = (props: LucideProps) => (
  <Icon icon={Check} {...props} />
)
CheckIcon.displayName = 'CheckIcon'

export const ChevronDownIcon = (props: LucideProps) => (
  <Icon icon={ChevronDown} {...props} />
)
ChevronDownIcon.displayName = 'ChevronDownIcon'

export const ChevronUpIcon = (props: LucideProps) => (
  <Icon icon={ChevronUp} {...props} />
)
ChevronUpIcon.displayName = 'ChevronUpIcon'

export const SendIcon = (props: LucideProps) => <Icon icon={Send} {...props} />
SendIcon.displayName = 'SendIcon'

export const XIcon = (props: LucideProps) => <Icon icon={X} {...props} />
XIcon.displayName = 'XIcon'

export const MinusIcon = (props: LucideProps) => (
  <Icon icon={Minus} {...props} />
)
MinusIcon.displayName = 'MinusIcon'

export const BookmarkIcon = (props: LucideProps) => (
  <Icon icon={Bookmark} {...props} />
)
BookmarkIcon.displayName = 'BookmarkIcon'

export const HeartIcon = (props: LucideProps) => (
  <Icon icon={Heart} {...props} />
)
HeartIcon.displayName = 'HeartIcon'

export const StarIcon = (props: LucideProps) => <Icon icon={Star} {...props} />
StarIcon.displayName = 'StarIcon'

export const BoldIcon = (props: LucideProps) => <Icon icon={Bold} {...props} />
BoldIcon.displayName = 'BoldIcon'

export const ItalicIcon = (props: LucideProps) => (
  <Icon icon={Italic} {...props} />
)
ItalicIcon.displayName = 'ItalicIcon'

export const UnderlineIcon = (props: LucideProps) => (
  <Icon icon={Underline} {...props} />
)
UnderlineIcon.displayName = 'UnderlineIcon'

export const StrikethroughIcon = (props: LucideProps) => (
  <Icon icon={Strikethrough} {...props} />
)
StrikethroughIcon.displayName = 'StrikethroughIcon'

export const AlignLeftIcon = (props: LucideProps) => (
  <Icon icon={AlignLeft} {...props} />
)
AlignLeftIcon.displayName = 'AlignLeftIcon'

export const AlignCenterIcon = (props: LucideProps) => (
  <Icon icon={AlignCenter} {...props} />
)
AlignCenterIcon.displayName = 'AlignCenterIcon'

export const AlignRightIcon = (props: LucideProps) => (
  <Icon icon={AlignRight} {...props} />
)
AlignRightIcon.displayName = 'AlignRightIcon'

export const AlignJustifyIcon = (props: LucideProps) => (
  <Icon icon={AlignJustify} {...props} />
)
AlignJustifyIcon.displayName = 'AlignJustifyIcon'

export const CircleIcon = (props: LucideProps) => (
  <Icon icon={Circle} {...props} />
)
CircleIcon.displayName = 'CircleIcon'

export const SquareIcon = (props: LucideProps) => (
  <Icon icon={Square} {...props} />
)
SquareIcon.displayName = 'SquareIcon'

export const TriangleIcon = (props: LucideProps) => (
  <Icon icon={Triangle} {...props} />
)
TriangleIcon.displayName = 'TriangleIcon'

export const TagIcon = (props: LucideProps) => <Icon icon={Tag} {...props} />
TagIcon.displayName = 'TagIcon'

export const FlagIcon = (props: LucideProps) => <Icon icon={Flag} {...props} />
FlagIcon.displayName = 'FlagIcon'

export const BellIcon = (props: LucideProps) => <Icon icon={Bell} {...props} />
BellIcon.displayName = 'BellIcon'

export const InfoIcon = (props: LucideProps) => <Icon icon={Info} {...props} />
InfoIcon.displayName = 'InfoIcon'

export const UserIcon = (props: LucideProps) => <Icon icon={User} {...props} />
UserIcon.displayName = 'UserIcon'

export const HomeIcon = (props: LucideProps) => <Icon icon={Home} {...props} />
HomeIcon.displayName = 'HomeIcon'

export const SettingsIcon = (props: LucideProps) => (
  <Icon icon={Settings} {...props} />
)
SettingsIcon.displayName = 'SettingsIcon'

export const ZapIcon = (props: LucideProps) => <Icon icon={Zap} {...props} />
ZapIcon.displayName = 'ZapIcon'

export const AwardIcon = (props: LucideProps) => (
  <Icon icon={Award} {...props} />
)
AwardIcon.displayName = 'AwardIcon'

export const CalendarIcon = (props: LucideProps) => (
  <Icon icon={Calendar} {...props} />
)
CalendarIcon.displayName = 'CalendarIcon'

export const LogOutIcon = (props: LucideProps) => (
  <Icon icon={LogOut} {...props} />
)
LogOutIcon.displayName = 'LogOutIcon'

export const PlusIcon = (props: LucideProps) => <Icon icon={Plus} {...props} />
PlusIcon.displayName = 'PlusIcon'

export const GripVerticalIcon = (props: LucideProps) => (
  <Icon icon={GripVertical} {...props} />
)
GripVerticalIcon.displayName = 'GripVerticalIcon'

export const FileIcon = (props: LucideProps) => <Icon icon={File} {...props} />
FileIcon.displayName = 'FileIcon'

export const FilePlusCornerIcon = (props: LucideProps) => (
  <Icon icon={FilePlusCorner} {...props} />
)
FilePlusCornerIcon.displayName = 'FilePlusCornerIcon'

export const FileCheckCornerIcon = (props: LucideProps) => (
  <Icon icon={FileCheckCorner} {...props} />
)
FileCheckCornerIcon.displayName = 'FileCheckCornerIcon'

export const FolderIcon = (props: LucideProps) => (
  <Icon icon={Folder} {...props} />
)
FolderIcon.displayName = 'FolderIcon'

export const FolderOpenIcon = (props: LucideProps) => (
  <Icon icon={FolderOpen} {...props} />
)
FolderOpenIcon.displayName = 'FolderOpenIcon'

export const ArchiveIcon = (props: LucideProps) => (
  <Icon icon={Archive} {...props} />
)
ArchiveIcon.displayName = 'ArchiveIcon'

export const MailIcon = (props: LucideProps) => <Icon icon={Mail} {...props} />
MailIcon.displayName = 'MailIcon'

export const GoogleIcon = ({
  size = 24,
  className,
  ...props
}: LucideProps) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={cn('shrink-0', className)}
    {...props}
  >
    <path
      fill="#4285f4"
      d="M21.6 12.23c0-.71-.06-1.4-.18-2.07H12v3.91h5.38a4.6 4.6 0 0 1-2 3.02v2.54h3.24c1.9-1.75 2.98-4.33 2.98-7.4Z"
    />
    <path
      fill="#34a853"
      d="M12 22c2.7 0 4.98-.9 6.63-2.43l-3.24-2.53a6.02 6.02 0 0 1-8.97-3.17H3.08v2.61A10 10 0 0 0 12 22Z"
    />
    <path
      fill="#fbbc05"
      d="M6.42 13.87A6.02 6.02 0 0 1 6.1 12c0-.65.11-1.28.32-1.87V7.52H3.08A10 10 0 0 0 2 12c0 1.61.39 3.14 1.08 4.48l3.34-2.61Z"
    />
    <path
      fill="#ea4335"
      d="M12 5.98c1.47 0 2.8.51 3.84 1.5l2.87-2.88A9.64 9.64 0 0 0 12 2a10 10 0 0 0-8.92 5.52l3.34 2.61A5.96 5.96 0 0 1 12 5.98Z"
    />
  </svg>
)
GoogleIcon.displayName = 'GoogleIcon'

export const MessageSquareIcon = (props: LucideProps) => (
  <Icon icon={MessageSquare} {...props} />
)
MessageSquareIcon.displayName = 'MessageSquareIcon'

export const PlusCircleIcon = (props: LucideProps) => (
  <Icon icon={PlusCircle} {...props} />
)
PlusCircleIcon.displayName = 'PlusCircleIcon'

export const UserPlusIcon = (props: LucideProps) => (
  <Icon icon={UserPlus} {...props} />
)
UserPlusIcon.displayName = 'UserPlusIcon'

export const CreditCardIcon = (props: LucideProps) => (
  <Icon icon={CreditCard} {...props} />
)
CreditCardIcon.displayName = 'CreditCardIcon'

export const KeyboardIcon = (props: LucideProps) => (
  <Icon icon={Keyboard} {...props} />
)
KeyboardIcon.displayName = 'KeyboardIcon'

export const UsersIcon = (props: LucideProps) => (
  <Icon icon={Users} {...props} />
)
UsersIcon.displayName = 'UsersIcon'

export const GithubIcon = (props: LucideProps) => (
  <Icon icon={Github} {...props} />
)
GithubIcon.displayName = 'GithubIcon'

export const ArrowUpDownIcon = (props: LucideProps) => (
  <Icon icon={ArrowUpDown} {...props} />
)
ArrowUpDownIcon.displayName = 'ArrowUpDownIcon'

export const ChevronsUpDownIcon = (props: LucideProps) => (
  <Icon icon={ChevronsUpDown} {...props} />
)
ChevronsUpDownIcon.displayName = 'ChevronsUpDownIcon'

export const WandIcon = (props: LucideProps) => <Icon icon={Wand} {...props} />
WandIcon.displayName = 'WandIcon'

export const RotateCwIcon = (props: LucideProps) => (
  <Icon icon={RotateCw} {...props} />
)
RotateCwIcon.displayName = 'RotateCwIcon'

export const ChevronRightIcon = (props: LucideProps) => (
  <Icon icon={ChevronRight} {...props} />
)
ChevronRightIcon.displayName = 'ChevronRightIcon'

export const FilterIcon = (props: LucideProps) => (
  <Icon icon={FilterLucide} {...props} />
)
FilterIcon.displayName = 'FilterIcon'

export const TextIcon = (props: LucideProps) => <Icon icon={Text} {...props} />
TextIcon.displayName = 'TextIcon'

export const HashIcon = (props: LucideProps) => <Icon icon={Hash} {...props} />
HashIcon.displayName = 'HashIcon'

export const ListIcon = (props: LucideProps) => <Icon icon={List} {...props} />
ListIcon.displayName = 'ListIcon'

export const ToggleLeftIcon = (props: LucideProps) => (
  <Icon icon={ToggleLeft} {...props} />
)
ToggleLeftIcon.displayName = 'ToggleLeftIcon'

export const PanelLeftIcon = (props: LucideProps) => (
  <Icon icon={PanelLeft} {...props} />
)
PanelLeftIcon.displayName = 'PanelLeftIcon'

export const UploadIcon = (props: LucideProps) => (
  <Icon icon={Upload} {...props} />
)
UploadIcon.displayName = 'UploadIcon'

export const ChevronLeftIcon = (props: LucideProps) => (
  <Icon icon={ChevronLeft} {...props} />
)
ChevronLeftIcon.displayName = 'ChevronLeftIcon'

export const MoreHorizontalIcon = (props: LucideProps) => (
  <Icon icon={MoreHorizontal} {...props} />
)
MoreHorizontalIcon.displayName = 'MoreHorizontalIcon'

export const CircleAlertIcon = (props: LucideProps) => (
  <Icon icon={CircleAlert} {...props} />
)
CircleAlertIcon.displayName = 'CircleAlertIcon'

export const TriangleAlertIcon = (props: LucideProps) => (
  <Icon icon={TriangleAlert} {...props} />
)
TriangleAlertIcon.displayName = 'TriangleAlertIcon'

export const OctagonAlertIcon = (props: LucideProps) => (
  <Icon icon={OctagonAlert} {...props} />
)
OctagonAlertIcon.displayName = 'OctagonAlertIcon'

export const CircleCheckIcon = (props: LucideProps) => (
  <Icon icon={CircleCheck} {...props} />
)
CircleCheckIcon.displayName = 'CircleCheckIcon'

export const InboxIcon = (props: LucideProps) => (
  <Icon icon={Inbox} {...props} />
)
InboxIcon.displayName = 'InboxIcon'

export const SearchIcon = (props: LucideProps) => (
  <Icon icon={Search} {...props} />
)
SearchIcon.displayName = 'SearchIcon'

export const FileTextIcon = (props: LucideProps) => (
  <Icon icon={FileText} {...props} />
)
FileTextIcon.displayName = 'FileTextIcon'

export const LayersIcon = (props: LucideProps) => (
  <Icon icon={Layers} {...props} />
)
LayersIcon.displayName = 'LayersIcon'

export const LayoutIcon = (props: LucideProps) => (
  <Icon icon={Layout} {...props} />
)
LayoutIcon.displayName = 'LayoutIcon'

export const PuzzleIcon = (props: LucideProps) => (
  <Icon icon={Puzzle} {...props} />
)
PuzzleIcon.displayName = 'PuzzleIcon'

export const BookMarkedIcon = (props: LucideProps) => (
  <Icon icon={BookMarked} {...props} />
)
BookMarkedIcon.displayName = 'BookMarkedIcon'

export const Edit2Icon = (props: LucideProps) => (
  <Icon icon={Edit2} {...props} />
)
Edit2Icon.displayName = 'Edit2Icon'

export const ClipboardPasteIcon = (props: LucideProps) => (
  <Icon icon={ClipboardPaste} {...props} />
)
ClipboardPasteIcon.displayName = 'ClipboardPasteIcon'

export const LoaderCircleIcon = (props: LucideProps) => (
  <Icon icon={LoaderCircle} {...props} />
)
LoaderCircleIcon.displayName = 'LoaderCircleIcon'

export const EllipsisVerticalIcon = (props: LucideProps) => (
  <Icon icon={EllipsisVertical} {...props} />
)
EllipsisVerticalIcon.displayName = 'EllipsisVerticalIcon'

export const Share2Icon = (props: LucideProps) => (
  <Icon icon={Share2} {...props} />
)
Share2Icon.displayName = 'Share2Icon'

export const Undo2Icon = (props: LucideProps) => (
  <Icon icon={Undo2} {...props} />
)
Undo2Icon.displayName = 'Undo2Icon'

export const Redo2Icon = (props: LucideProps) => (
  <Icon icon={Redo2} {...props} />
)
Redo2Icon.displayName = 'Redo2Icon'

export const PenIcon = (props: LucideProps) => <Icon icon={Pen} {...props} />
PenIcon.displayName = 'PenIcon'

export const PaintbrushIcon = (props: LucideProps) => (
  <Icon icon={Paintbrush} {...props} />
)
PaintbrushIcon.displayName = 'PaintbrushIcon'

export const EraserIcon = (props: LucideProps) => (
  <Icon icon={Eraser} {...props} />
)
EraserIcon.displayName = 'EraserIcon'

export const EyeIcon = (props: LucideProps) => <Icon icon={Eye} {...props} />
EyeIcon.displayName = 'EyeIcon'

export const EyeOffIcon = (props: LucideProps) => (
  <Icon icon={EyeOff} {...props} />
)
EyeOffIcon.displayName = 'EyeOffIcon'

export const LockIcon = (props: LucideProps) => <Icon icon={Lock} {...props} />
LockIcon.displayName = 'LockIcon'

export const MicIcon = (props: LucideProps) => <Icon icon={Mic} {...props} />
MicIcon.displayName = 'MicIcon'

export const VideoIcon = (props: LucideProps) => (
  <Icon icon={Video} {...props} />
)
VideoIcon.displayName = 'VideoIcon'

/* oxlint-disable typescript/no-deprecated -- Youtube icon renamed in lucide but our alias is intentional */
export const YoutubeIcon = (props: LucideProps) => (
  <Icon icon={Youtube} {...props} />
)
/* oxlint-enable typescript/no-deprecated */
YoutubeIcon.displayName = 'YoutubeIcon'

export const FileImageIcon = (props: LucideProps) => (
  <Icon icon={FileImage} {...props} />
)
FileImageIcon.displayName = 'FileImageIcon'

export const FileVideoCameraIcon = (props: LucideProps) => (
  <Icon icon={FileVideoCamera} {...props} />
)
FileVideoCameraIcon.displayName = 'FileVideoCameraIcon'

export const FileMusicIcon = (props: LucideProps) => (
  <Icon icon={FileMusic} {...props} />
)
FileMusicIcon.displayName = 'FileMusicIcon'

export const FileSpreadsheetIcon = (props: LucideProps) => (
  <Icon icon={FileSpreadsheet} {...props} />
)
FileSpreadsheetIcon.displayName = 'FileSpreadsheetIcon'

export const FileArchiveIcon = (props: LucideProps) => (
  <Icon icon={FileArchive} {...props} />
)
FileArchiveIcon.displayName = 'FileArchiveIcon'

export const PlayIcon = (props: LucideProps) => <Icon icon={Play} {...props} />
PlayIcon.displayName = 'PlayIcon'

export const PauseIcon = (props: LucideProps) => (
  <Icon icon={Pause} {...props} />
)
PauseIcon.displayName = 'PauseIcon'

export const HeadphonesIcon = (props: LucideProps) => <Icon icon={Headphones} {...props} />
HeadphonesIcon.displayName = 'HeadphonesIcon'

export const SkipBackIcon = (props: LucideProps) => <Icon icon={SkipBack} {...props} />
SkipBackIcon.displayName = 'SkipBackIcon'

export const SkipForwardIcon = (props: LucideProps) => <Icon icon={SkipForward} {...props} />
SkipForwardIcon.displayName = 'SkipForwardIcon'

export const ListTodoIcon = (props: LucideProps) => (
  <Icon icon={ListTodo} {...props} />
)
ListTodoIcon.displayName = 'ListTodoIcon'

export const BrushIcon = (props: LucideProps) => (
  <Icon icon={Brush} {...props} />
)
BrushIcon.displayName = 'BrushIcon'

export const ImageIcon = (props: LucideProps) => (
  <Icon icon={Image} {...props} />
)
ImageIcon.displayName = 'ImageIcon'

export const Trash2Icon = (props: LucideProps) => (
  <Icon icon={Trash2} {...props} />
)
Trash2Icon.displayName = 'Trash2Icon'

export const AlarmClockIcon = (props: LucideProps) => (
  <Icon icon={AlarmClock} {...props} />
)
AlarmClockIcon.displayName = 'AlarmClockIcon'

export const SlashIcon = (props: LucideProps) => (
  <Icon icon={Slash} {...props} />
)
SlashIcon.displayName = 'SlashIcon'

export const CopyIcon = (props: LucideProps) => <Icon icon={Copy} {...props} />
CopyIcon.displayName = 'CopyIcon'

export const PencilIcon = (props: LucideProps) => (
  <Icon icon={Pencil} {...props} />
)
PencilIcon.displayName = 'PencilIcon'

export const RotateCcwIcon = (props: LucideProps) => (
  <Icon icon={RotateCcw} {...props} />
)
RotateCcwIcon.displayName = 'RotateCcwIcon'

export const ServerCogIcon = (props: LucideProps) => (
  <Icon icon={ServerCog} {...props} />
)
ServerCogIcon.displayName = 'ServerCogIcon'

export const MicroscopeIcon = (props: LucideProps) => (
  <Icon icon={Microscope} {...props} />
)
MicroscopeIcon.displayName = 'MicroscopeIcon'

export const SearchCodeIcon = (props: LucideProps) => (
  <Icon icon={SearchCode} {...props} />
)
SearchCodeIcon.displayName = 'SearchCodeIcon'

export const CodeXmlIcon = (props: LucideProps) => (
  <Icon icon={CodeXml} {...props} />
)
CodeXmlIcon.displayName = 'CodeXmlIcon'

export const TreePalmIcon = (props: LucideProps) => (
  <Icon icon={TreePalm} {...props} />
)
TreePalmIcon.displayName = 'TreePalmIcon'

export const RouteIcon = (props: LucideProps) => (
  <Icon icon={Route} {...props} />
)
RouteIcon.displayName = 'RouteIcon'

export const ActivityIcon = (props: LucideProps) => (
  <Icon icon={Activity} {...props} />
)
ActivityIcon.displayName = 'ActivityIcon'

export const DownloadIcon = (props: LucideProps) => (
  <Icon icon={Download} {...props} />
)
DownloadIcon.displayName = 'DownloadIcon'

export const FullscreenIcon = (props: LucideProps) => (
  <Icon icon={Maximize2} {...props} />
)
FullscreenIcon.displayName = 'FullscreenIcon'

export const ExitFullscreenIcon = (props: LucideProps) => (
  <Icon icon={Minimize2} {...props} />
)
ExitFullscreenIcon.displayName = 'ExitFullscreenIcon'

export const PhoneIcon = (props: LucideProps) => (
  <Icon icon={Phone} {...props} />
)
PhoneIcon.displayName = 'PhoneIcon'

export const BriefcaseIcon = (props: LucideProps) => (
  <Icon icon={Briefcase} {...props} />
)
BriefcaseIcon.displayName = 'BriefcaseIcon'

export const CircleUserRoundIcon = (props: LucideProps) => (
  <Icon icon={CircleUserRound} {...props} />
)
CircleUserRoundIcon.displayName = 'CircleUserRoundIcon'

export const Volume2Icon = (props: LucideProps) => (
  <Icon icon={Volume2} {...props} />
)
Volume2Icon.displayName = 'Volume2Icon'

export const VolumeXIcon = (props: LucideProps) => (
  <Icon icon={VolumeX} {...props} />
)
VolumeXIcon.displayName = 'VolumeXIcon'

export const SunIcon = (props: LucideProps) => <Icon icon={Sun} {...props} />
SunIcon.displayName = 'SunIcon'

export const MoonIcon = (props: LucideProps) => <Icon icon={Moon} {...props} />
MoonIcon.displayName = 'MoonIcon'

export const WifiOffIcon = (props: LucideProps) => (
  <Icon icon={WifiOff} {...props} />
)
WifiOffIcon.displayName = 'WifiOffIcon'

export const RabbitIcon = (props: LucideProps) => (
  <Icon icon={Rabbit} {...props} />
)
RabbitIcon.displayName = 'RabbitIcon'

export const TurtleIcon = (props: LucideProps) => (
  <Icon icon={Turtle} {...props} />
)
TurtleIcon.displayName = 'TurtleIcon'

export const CircleXIcon = (props: LucideProps) => (
  <Icon icon={CircleX} {...props} />
)
CircleXIcon.displayName = 'CircleXIcon'

export const HardDriveIcon = (props: LucideProps) => (
  <Icon icon={HardDrive} {...props} />
)
HardDriveIcon.displayName = 'HardDriveIcon'

export const CloudIcon = (props: LucideProps) => (
  <Icon icon={Cloud} {...props} />
)
CloudIcon.displayName = 'CloudIcon'

export const DatabaseIcon = (props: LucideProps) => (
  <Icon icon={Database} {...props} />
)
DatabaseIcon.displayName = 'DatabaseIcon'
export const GlobeIcon = (props: LucideProps) => (
  <Icon icon={Globe} {...props} />
)
export const AlertCircleIcon = (props: LucideProps) => (
  <Icon icon={AlertCircle} {...props} />
)
export const ClockIcon = (props: LucideProps) => (
  <Icon icon={Clock} {...props} />
)
export const ArrowLeftIcon = (props: LucideProps) => (
  <Icon icon={ArrowLeft} {...props} />
)
export const XCircleIcon = (props: LucideProps) => (
  <Icon icon={XCircle} {...props} />
)
export const ServerIcon = (props: LucideProps) => (
  <Icon icon={Server} {...props} />
)
export const ExternalLinkIcon = (props: LucideProps) => (
  <Icon icon={ExternalLink} {...props} />
)
export const FileCodeIcon = (props: LucideProps) => (
  <Icon icon={FileCode} {...props} />
)
export const PackageIcon = (props: LucideProps) => (
  <Icon icon={Package} {...props} />
)
export const BugIcon = (props: LucideProps) => <Icon icon={Bug} {...props} />
BugIcon.displayName = 'BugIcon'

type TrainingLevel = 'low' | 'medium' | 'high'
type TrainingLevelIconProps = LucideProps & { level: TrainingLevel }

const ImportanceLow = createLucideIcon('ImportanceLow', [
  ['rect', { x: '2', y: '12', width: '5', height: '10', rx: '2.5', fill: 'currentColor', stroke: 'none', key: '0' }],
  ['rect', { x: '17.5', y: '2.5', width: '4', height: '19', rx: '2', fill: 'none', stroke: 'currentColor', key: '1' }],
  ['rect', { x: '10', y: '7.5', width: '4', height: '14', rx: '2', fill: 'none', stroke: 'currentColor', key: '2' }],
])
const ImportanceMedium = createLucideIcon('ImportanceMedium', [
  ['rect', { x: '2', y: '12', width: '5', height: '10', rx: '2.5', fill: 'currentColor', stroke: 'none', key: '0' }],
  ['rect', { x: '17.5', y: '2.5', width: '4', height: '19', rx: '2', fill: 'none', stroke: 'currentColor', key: '1' }],
  ['rect', { x: '9.5', y: '7', width: '5', height: '15', rx: '2.5', fill: 'currentColor', stroke: 'none', key: '2' }],
])
const ImportanceHigh = createLucideIcon('ImportanceHigh', [
  ['rect', { x: '2', y: '12', width: '5', height: '10', rx: '2.5', fill: 'currentColor', stroke: 'none', key: '0' }],
  ['rect', { x: '17', y: '2', width: '5', height: '20', rx: '2.5', fill: 'currentColor', stroke: 'none', key: '1' }],
  ['rect', { x: '9.5', y: '7', width: '5', height: '15', rx: '2.5', fill: 'currentColor', stroke: 'none', key: '2' }],
])
const importanceLevels = { low: ImportanceLow, medium: ImportanceMedium, high: ImportanceHigh }
export function ImportanceLevelIcon({ level, ...props }: TrainingLevelIconProps) {
  return <Icon icon={importanceLevels[level]} strokeWidth={1} aria-hidden={true} {...props} />
}
ImportanceLevelIcon.displayName = 'ImportanceLevelIcon'

const DifficultyLow = createLucideIcon('DifficultyLow', [
  ['rect', { x: '2', y: '17', width: '20', height: '5', rx: '2.5', fill: 'currentColor', stroke: 'none', key: '0' }],
  ['rect', { x: '2.5', y: '2.5', width: '19', height: '4', rx: '2', fill: 'none', stroke: 'currentColor', key: '1' }],
  ['rect', { x: '2.5', y: '10', width: '19', height: '4', rx: '2', fill: 'none', stroke: 'currentColor', key: '2' }],
])
const DifficultyMedium = createLucideIcon('DifficultyMedium', [
  ['rect', { x: '2', y: '17', width: '20', height: '5', rx: '2.5', fill: 'currentColor', stroke: 'none', key: '0' }],
  ['rect', { x: '2.5', y: '2.5', width: '19', height: '4', rx: '2', fill: 'none', stroke: 'currentColor', key: '1' }],
  ['rect', { x: '2', y: '9.5', width: '20', height: '5', rx: '2.5', fill: 'currentColor', stroke: 'none', key: '2' }],
])
const DifficultyHigh = createLucideIcon('DifficultyHigh', [
  ['rect', { x: '2', y: '17', width: '20', height: '5', rx: '2.5', fill: 'currentColor', stroke: 'none', key: '0' }],
  ['rect', { x: '2', y: '2', width: '20', height: '5', rx: '2.5', fill: 'currentColor', stroke: 'none', key: '1' }],
  ['rect', { x: '2', y: '9.5', width: '20', height: '5', rx: '2.5', fill: 'currentColor', stroke: 'none', key: '2' }],
])
const difficultyLevels = { low: DifficultyLow, medium: DifficultyMedium, high: DifficultyHigh }
export function DifficultyLevelIcon({ level, ...props }: TrainingLevelIconProps) {
  return <Icon icon={difficultyLevels[level]} strokeWidth={1} aria-hidden={true} {...props} />
}
DifficultyLevelIcon.displayName = 'DifficultyLevelIcon'

export const LanguagesIcon = (props: LucideProps) => <Icon icon={Languages} {...props} />
LanguagesIcon.displayName = 'LanguagesIcon'

export const CircleHelpIcon = (props: LucideProps) => (
  <Icon icon={CircleHelp} {...props} />
)
CircleHelpIcon.displayName = 'CircleHelpIcon'

export const SmilePlusIcon = (props: LucideProps) => <Icon icon={SmilePlus} {...props} />
SmilePlusIcon.displayName = 'SmilePlusIcon'

export const ArrowUpIcon = (props: LucideProps) => <Icon icon={ArrowUp} {...props} />
ArrowUpIcon.displayName = 'ArrowUpIcon'

export const ArrowDownIcon = (props: LucideProps) => <Icon icon={ArrowDown} {...props} />
ArrowDownIcon.displayName = 'ArrowDownIcon'

export const IndentIncreaseIcon = (props: LucideProps) => <Icon icon={IndentIncrease} {...props} />
IndentIncreaseIcon.displayName = 'IndentIncreaseIcon'

export const IndentDecreaseIcon = (props: LucideProps) => <Icon icon={IndentDecrease} {...props} />
IndentDecreaseIcon.displayName = 'IndentDecreaseIcon'
